// removed by extract-text-webpack-plugin
module.exports = {"app":"theme__app___137ct","main":"theme__main___V98Ww","fadeUp":"theme__fadeUp___3YUG7","lateFadeUp":"theme__lateFadeUp___BHObU","lateFadeIn":"theme__lateFadeIn___20dci"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Main/Layout/theme.scss
// module id = 1320
// module chunks = 0